import { RequestService } from '@/services/request.service'
import Vue from 'vue'

const requestService = new RequestService()

const state = {
  message: {
    text: null,
    color: null,
    show: null,
    timeout: parseInt(process.env.VUE_APP_MESSAGE_TIMEOUT, 10)
  },
  token: null,
  facilityId: null
}

const getters = {
  token: state => state.token,
  facilityId: state => state.facilityId
}

const actions = {
  handleFormError ({ commit }, {
    error, // body: { errors: [] }
    errors, // Array
    value, // Error identifier value
    path, // Error identifier path. Default is "name"
    savePath, // Property name to save with instead of name prop
    text, // Value to save
    condition, // Function,
    noRemoval, // Boolean. Used when multiple errors for same value
    isMessage  // Boolean. Sets message to module instead of formError
  }) {
    const array = errors || (error && error.body ? error.body.errors : [])
    const _path = path || 'name'
    let foundError = null
    if (Array.isArray(array)) {
      foundError = array.find(e => (e[_path] === value) && (condition ? condition(e) : true))
    }
    if (foundError) {
      if (isMessage) {
        commit('setMessage', { text, color: 'error' })
      } else {
        commit('addFormError', { [savePath || value]: [text] })
      }
    } else if (!noRemoval) {
      commit('deleteFormError', savePath || value)
    }
    return foundError
  }
}

const mutations = {
  setMessage (state, message) {
    state.message.text = message.text
    state.message.color = message.color
    state.message.timeout = message.timeout
    state.message.show = true
  },
  setToken (state, token) {
    console.log('Token: ', token)
    state.token = token
  },
  setFacilityId (state, facilityId) {
    console.log('FacilityId (query param): ', facilityId)
    state.facilityId = facilityId
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
